import React from "react";
import Alert from "@mui/material/Alert";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { Box, Button, Divider, Grid, Stack, Typography } from "@mui/material";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { makeStyles } from "@mui/styles";
import StarsErrorIcon from "../components/StarsErrorIcon";
import StarsWarningIcon from "../components/StarsWarningIcon";

import {
  ALL,
  FULL_TIME,
  PART_TIME,
  ALL_ISSUES,
  CRITICAL_ISSUES,
  NON_CRITICAL_ISSUES,
  GO_ADMIN_EMAIL_ADDRESS,
} from "../util/constants";

const useStyles = makeStyles((theme) => ({
  root: {
    margin: "auto",
    position: "fixed",
    width: "100%",
  },
  breadCrumb: {
    marginLeft: "2.5vw",
  },
  desktopTitle: {
    marginLeft: "4.2vw",
  },
  seniorityListBox: {
    margin: "auto",
    width: "100%",
    paddingRight: "3.8vw",
    paddingLeft: "4.25vw",
  },
  seniorityInput: {
    margin: "5px",
  },
  seniorityFullPartTimeExport: {
    display: "flex",
    justifyContent: "space-between",
    marginLeft: "4.25vw",
    marginRight: "3.8vw",
    paddingTop: "0.3vw",
    paddingBottom: "0.4vw",
  },
  publishButton: {
    display: "flex-end",
  },
  toggleButtonGroup: {
    "& .MuiButtonBase-root": {
      color: theme.palette.primary.main,
      borderColor: theme.palette.primary.main,
      padding: " 6px 14px",
    },
    "& .Mui-selected": {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
    },
    "& .MuiButtonBase-root:hover": {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      opacity: 0.6,
    },
  },
  issuesToggle: {
    "&:hover": {
      backgroundColor: theme.palette.secondary.swaLightBlue,
    },
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
  },
  issueSelected: {
    backgroundColor: theme.palette.secondary.swaLightBlue,
  },
  exportButton: {},
  inprogressTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginLeft: "4.2vw",
    marginRight: "3.9vw",
  },
  inprogressMessage: {
    textAlign: "left",
    fontSize: "14px",
  },
}));
const mailtoHref = `mailto:${GO_ADMIN_EMAIL_ADDRESS}`;
const SENIORITY_LIST_TABLE_HEIGHT = `calc(85vh - 385px)`;

const InProgressSeniorityListPage = (props) => {
  const classes = useStyles();

  return (
    <>
      <Grid className={classes.inprogressTitle}>
        <Grid item className={classes.inprogressMessage}>
          This Seniority List is created from the latest data in STARS. Click the Publish button to generate and publish
          the Seniority List.
        </Grid>
        <Grid item>
          <Button
            data-testid="seniorityListPage-publish-button"
            className={classes.publishButton}
            variant="contained"
            color="primary"
            size="medium"
            onClick={() => {
              props.setIsPublishSLDialogOpen(true);
            }}
            disabled={props.isLoading || props.criticalMissingDataCount > 0 || !props.seniorityList.length}
          >
            PUBLISH
          </Button>
        </Grid>
      </Grid>
      <div className={`${classes.seniorityInput} ${classes.seniorityFullPartTimeExport}`}>
        <ToggleButtonGroup
          size="small"
          exclusive
          value={props.filterSetting}
          onChange={props.handleFilterSettingChange}
          color={"primary"}
          className={classes.toggleButtonGroup}
        >
          <ToggleButton value={FULL_TIME}>FT {props.ftCount !== "" ? "(" + props.ftCount + ")" : ""}</ToggleButton>
          <ToggleButton value={PART_TIME}>PT {props.ptCount !== "" ? "(" + props.ptCount + ")" : ""}</ToggleButton>
          <ToggleButton value={ALL}>
            ALL
            {props.ftCount !== ""
              ? "(" + (props.ftCount === "-" ? props.ftCount : props.ftCount + props.ptCount) + ")"
              : ""}
          </ToggleButton>
        </ToggleButtonGroup>

        <Button
          data-testid="seniorityListPage-inprogress-export-button"
          className={classes.exportButton}
          variant="contained"
          color="primary"
          size="medium"
          onClick={props.handleCsvMenuItemClick}
          startIcon={<UploadFileIcon />}
          disabled={props.isLoading || !props.seniorityList.length}
        >
          Export CSV
        </Button>
      </div>
      <div hidden={props.selectedTab !== 0}>
        <div className={classes.seniorityListBox}>
          <Grid container>
            <Box
              sx={{
                bgcolor: "secondary.swaLightestBlue",
                width: "100%",
                height: "50px",
                borderTopLeftRadius: "5px",
                borderTopRightRadius: "5px",
                borderTop: "solid 1px",
                borderLeft: "solid 1px",
                borderRight: "solid 1px",
                borderColor: "secondary.swaLightestBlue",
                overflow: "hidden",
              }}
            >
              <Stack
                sx={{ height: "100%", display: "flex", justifyContent: "left", alignItems: "center" }}
                direction="row"
                divider={<Divider sx={{ marginTop: "5px", marginBottom: "5px" }} orientation="vertical" flexItem />}
              >
                <Box
                  sx={{
                    width: "8vw",
                  }}
                  onMouseDown={() =>
                    (props.criticalMissingDataCount > 0 || props.missingDataCount > 0) &&
                    props.handleIssuesFilter(ALL_ISSUES)
                  }
                  className={
                    (props.criticalMissingDataCount > 0 || props.missingDataCount > 0) &&
                    `${classes.issuesToggle} ${props.issuesFilter === ALL_ISSUES && classes.issueSelected}`
                  }
                >
                  <Typography
                    component="span"
                    sx={
                      props.criticalMissingDataCount > 0 || props.missingDataCount > 0
                        ? { textDecoration: "underline" }
                        : {}
                    }
                  >
                    {props.criticalMissingDataCount > 0 || props.missingDataCount > 0 ? "All Issues" : "No data issues"}
                  </Typography>
                </Box>
                {props.criticalMissingDataCount > 0 && (
                  <Box
                    sx={{
                      width: "30vw",
                    }}
                    onMouseDown={() => props.handleIssuesFilter(CRITICAL_ISSUES)}
                    className={`${classes.issuesToggle} ${
                      props.issuesFilter === CRITICAL_ISSUES && classes.issueSelected
                    }`}
                  >
                    <StarsErrorIcon />
                    <Typography component="span" sx={{ textDecoration: "underline", paddingLeft: "10px" }}>
                      {props.criticalMissingDataCount}
                      {` Employee${props.criticalMissingDataCount === 1 ? "" : "s"} with critical data missing`}
                    </Typography>
                  </Box>
                )}
                {props.missingDataCount > 0 && (
                  <Box
                    sx={{
                      width: "30vw",
                    }}
                    onMouseDown={() => props.handleIssuesFilter(NON_CRITICAL_ISSUES)}
                    className={`${classes.issuesToggle} ${
                      props.issuesFilter === NON_CRITICAL_ISSUES && classes.issueSelected
                    }`}
                  >
                    <StarsWarningIcon />
                    <Typography component="span" sx={{ textDecoration: "underline", paddingLeft: "10px" }}>
                      {props.missingDataCount}
                      {` Employee${props.missingDataCount === 1 ? "" : "s"} with non-critical data missing`}
                    </Typography>
                  </Box>
                )}
              </Stack>
            </Box>
            {props.seniorityList.length > 0 && (
              <Box
                sx={{
                  width: "100%",
                  height: "50px",
                  borderTop: "solid 1px",
                  borderLeft: "solid 1px",
                  borderRight: "solid 1px",
                  borderColor: "secondary.swaGray2",
                }}
              >
                <Alert severity="error" style={{ fontWeight: "bold" }}>
                  Contact <a href={mailtoHref}> {GO_ADMIN_EMAIL_ADDRESS}</a> to correct missing or incorrect data.
                </Alert>
              </Box>
            )}
          </Grid>
          <Box
            sx={{
              height: SENIORITY_LIST_TABLE_HEIGHT,
            }}
          >
            {props.renderSeniorityList(props.displayedSeniorityList)}
          </Box>
        </div>
      </div>
    </>
  );
};
export default InProgressSeniorityListPage;
